"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Report = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Report = function Report(_ref) {
  var _tour$report, _tour$report2, _tour$report3, _tour$report4, _tour$report5, _tour$report6;

  var tour = _ref.tour;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-0 px-1 pb-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (_tour$report = tour.report) !== null && _tour$report !== void 0 && _tour$report.showGeoInformation ? 'widgets.tourBoard.withPositionInformation' : 'widgets.tourBoard.withoutPositionInformation',
    tagName: "span"
  }), ((_tour$report2 = tour.report) === null || _tour$report2 === void 0 ? void 0 : _tour$report2.recipients.length) > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-2 bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.recipients",
    tagName: "span"
  }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, ((_tour$report3 = tour.report) === null || _tour$report3 === void 0 ? void 0 : _tour$report3.recipients) && tour.report.recipients.map(function (rec, index) {
    return "".concat(index > 0 ? ', ' : '').concat(rec);
  }))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-row"
  }, !((_tour$report4 = tour.report) !== null && _tour$report4 !== void 0 && _tour$report4.shareViaEmail) ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.uploadReportDetail",
    tagName: "span"
  }) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-row"
  }, !((_tour$report5 = tour.report) !== null && _tour$report5 !== void 0 && _tour$report5.shareViaEmail) && (_tour$report6 = tour.report) !== null && _tour$report6 !== void 0 && _tour$report6.uploadAsIdocFormat ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.Idoc",
    tagName: "span"
  }) : null));
};

exports.Report = Report;
Report.propTypes = {
  tour: _propTypes["default"].shape({
    report: _propTypes["default"].shape({
      recipients: _propTypes["default"].arrayOf(_propTypes["default"].string),
      showGeoInformation: _propTypes["default"].bool,
      shareViaEmail: _propTypes["default"].bool,
      uploadAsIdocFormat: _propTypes["default"].bool
    }),
    showGeoInformationInReport: _propTypes["default"].bool
  }).isRequired
};
Report.defaultProps = {};
var _default = Report;
exports["default"] = _default;